import { useApi } from '@/@diffrag/hooks/useApi'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { api } from '@/api'
import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import {
  IAdminQnaROO1,
  IAdminQnaUpdateO1,
  IAdminQnaUpdateO1ArticleStatusEnum,
  IAdminQnaUpdateO1InquiryStatusEnum,
} from 'api'
import parse from 'html-react-parser'
import { useNavigate } from 'react-router-dom'
import { toast } from '@/lib/toast'

export default function QnaDetail() {
  const id = useQueryValue('id', 0)
  const navigate = useNavigate()

  const { data } = useApi({
    id: 'qnaDetail',
    fn: api().admin.getQnaDetail,
    params: id,
    enabled: !!id,
  })

  const onSave = async (data: IAdminQnaROO1) => {
    if (!data.answer) {
      alert('답변을 입력해주세요.')
      return
    }

    if (!confirm('답변을 저장하시겠습니까?')) return

    await api().admin.updateQna(id, {
      answer: data.answer,
      articleStatus:
        data.articleStatus as unknown as IAdminQnaUpdateO1ArticleStatusEnum,
      inquiryStatus:
        data.inquiryStatus as unknown as IAdminQnaUpdateO1InquiryStatusEnum,
    })

    toast.success('답변이 저장되었습니다.')

    navigate(-1)
  }

  return (
    <ContentDetailView
      data={data}
      title="문의 상세"
      onSave={onSave}
      hideSaveToast={() => true}
    >
      <DetailForm
        data={data}
        fields={[
          {
            key: 'author.userData.nickname',
            label: '작성자(닉네임)',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'createDate',
            label: '작성일',
            type: FormFieldType.DATE,
            readOnly: true,
          },
          {
            label: '제목',
            key: 'title',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'content',
            label: '문의 상세내용',
            type: FormFieldType.CUSTOM_READ_ONLY,
            readOnly: true,
            render: (data) => <div>{parse(data?.content || '')}</div>,
          },
          {
            key: 'answer',
            label: '답변 작성',
            type: FormFieldType.TEXT,
          },
          {
            key: 'inquiryStatus',
            label: '상태',
            type: FormFieldType.SELECT,
            options: [
              { label: '답변대기', value: 'WAITING' },
              { label: '답변완료', value: 'ANSWERED' },
            ],
          },
        ]}
      />
    </ContentDetailView>
  )
}
